import { Injectable } from '@angular/core';
import { CountryDiseaseModel } from '../../../models/master-data/countries-diseases.model';
import { BaseService } from '../../../shared/services/base.service';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';

@Injectable()
export class CountriesDiseasesService {
    constructor(public baseService: BaseService) {

    }
    getCountryList(){
        const url = MasterDataUrl.GET_ALL_COUNTRY;
        return this.baseService.getData(url);
    }

    getDiseasesByCountry(param){
        const url = MasterDataUrl.GET_DISEASE_BY_COUNTRY;
        return this.baseService.getData(url, param);
    }

    getDiseaseList(){
        const url = MasterDataUrl.GET_ALL_DISEASE;
        return this.baseService.getData(url);
    }
    getTripList() {
        const url = MasterDataUrl.GET_ALL_TRIP_CATEGORY;
        return this.baseService.getData(url);
    }
    addNewCountryDisease(param){
        const url = MasterDataUrl.ADD_COUNTRY_DISEASE;
        return this.baseService.postData(url,param);
    }
    updateCountryDisease(id, param){
      const url = MasterDataUrl.UPDATE_COUNTRY_DISEASE + `${id}`;
      return this.baseService.put(url,param);
    }
    getCountryDisease(countryId,diseaseId) {
      const url = MasterDataUrl.GET_COUNTRY_DISEASE.replace('{countryId}/{diseaseId}', countryId + '/' +diseaseId);
      return this.baseService.getData(url);
    }
    deleteCountryDisease(countryId,diseaseId){
      const url = MasterDataUrl.REMOVE_COUNTRY_DISEASE.replace('{countryId}/{diseaseId}', countryId + '/' +diseaseId);
      return this.baseService.delete(url);
    }

}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/countries-diseases/countries-diseases.service.ts